export interface NavItem {
  label: string
  href: string
  children?: NavItem[]
}

export const PRIMARY_NAV: NavItem[] = [
  {
    label: 'What We Buy',
    href: '/coins-we-buy',
    children: [
      { label: 'Coins',            href: '/coins-we-buy' },
      { label: 'Jewelry',          href: '/jewelry-we-buy' },
      { label: 'Gold & Silver',    href: '/gold-silver-we-buy' },
      { label: 'Currency',         href: '/currency-we-buy' },
      { label: 'Vintage Watches',  href: '/vintage-watches-we-buy' },
      { label: 'Historical Items', href: '/historical-items-we-buy' },
    ],
  },
  { label: 'How It Works', href: '/how-it-works' },
  { label: 'Locations',    href: '/locations/west-bridgewater' },
  { label: 'About Us',     href: '/about' },
  { label: 'Contact',      href: '/contact' },
]

export const FOOTER_COLUMNS = [
  {
    heading: 'What We Buy',
    links: [
      { label: 'Coins',            href: '/coins-we-buy' },
      { label: 'Jewelry',          href: '/jewelry-we-buy' },
      { label: 'Gold & Silver',    href: '/gold-silver-we-buy' },
      { label: 'Currency',         href: '/currency-we-buy' },
      { label: 'Vintage Watches',  href: '/vintage-watches-we-buy' },
      { label: 'Historical Items', href: '/historical-items-we-buy' },
    ],
  },
  {
    heading: 'Our Locations',
    links: [
      { label: 'West Bridgewater', href: '/locations/west-bridgewater' },
      { label: 'Needham',          href: '/locations/needham' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About Us',      href: '/about' },
      { label: 'How It Works',  href: '/how-it-works' },
      { label: 'Testimonials',  href: '/testimonials' },
      { label: 'FAQs',          href: '/faqs' },
      { label: 'Contact',       href: '/contact' },
    ],
  },
]
